<div class="exit-dialog">
  <div class="exit-dialog__header">
    <mat-icon class="exit-dialog__icon">warning_amber</mat-icon>
    <h2 class="exit-dialog__title">{{ 'Unsaved Template Changes' | translate }}</h2>
  </div>
  <hr class="exit-dialog__divider exit-dialog__divider--title">
  <p class="exit-dialog__message">{{ 'You have unsaved changes to this template. What would you like to do?' | translate }}</p>
  <hr class="exit-dialog__divider">
  <div class="exit-dialog__actions">
    <button class="btn exit-dialog__btn exit-dialog__btn--stay" (click)="stay()">
      <mat-icon>edit</mat-icon>
      {{ 'Keep Editing' | translate }}
    </button>
    <button class="btn exit-dialog__btn exit-dialog__btn--discard" (click)="discard()">
      <mat-icon>delete_outline</mat-icon>
      {{ 'Discard Changes' | translate }}
    </button>
    <button class="btn exit-dialog__btn exit-dialog__btn--save" (click)="save()">
      <mat-icon>save</mat-icon>
      {{ 'Save & Exit' | translate }}
    </button>
  </div>
</div>
